export default __webpack_public_path__ + "8e0b67034af06780af3789a802286259.png";